import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SendIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5898 12.777C22.5898 13.1558 22.3758 13.5021 22.0371 13.6715L4.03706 22.6715C3.69201 22.844 3.2785 22.8026 2.97443 22.5652C2.67036 22.3278 2.52997 21.9367 2.61366 21.5601L4.56545 12.777L2.61366 3.99396C2.52997 3.61737 2.67036 3.22623 2.97443 2.98882C3.2785 2.75142 3.69201 2.71008 4.03706 2.8826L22.0371 11.8826C22.3758 12.052 22.5898 12.3983 22.5898 12.777ZM6.39201 13.777L5.02179 19.943L19.3538 12.777L5.0218 5.61104L6.39202 11.777L13.5898 11.777C14.1421 11.777 14.5898 12.2247 14.5898 12.777C14.5898 13.3293 14.1421 13.777 13.5898 13.777L6.39201 13.777Z"
            />
        </SvgIcon>
    );
};

export default SendIcon;
